import Visibility from "@mui/icons-material/Visibility";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { format, parseISO } from "date-fns";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import ExportButton from "../../commons/export/ExportButton";
import { tableConfig, tableStyles } from "../../commons/table/tableConfig";
import { StyledEstablecimientos } from "../../styled/Prevencion";
import EstablecimientosToolbar from "./EstablecimientosToolbar";

const EstablecimientosTable = ({
  data,
  loading,
  handleVerEstadoEstablecimiento,
}) => {

  const theme = useTheme();

  const columns = useMemo(() => [
    {
      header: "Nombre",
      accessorKey: "nombre",
      enableColumnActions: false,
      minWidth: 250,
      enableColumnFilter: true,
      filterVariant: 'text',
    },
    {
      header: "Domicilio",
      accessorKey: "domicilio",
      enableColumnActions: false,
      minWidth: 300,
      align: 'center',
      grow: true,
      enableColumnFilter: true,
      filterVariant: 'text',
    },
    {
      header: "Cód. Establecimiento",
      accessorKey: "codigoEstablecimiento",
      width: "10%",
      align: "center",
      enableColumnActions: false,
      type: "numeric",
      sorting: true,
      enableColumnFilter: false,
      xlsxConfig: {
        numberFormat: "@",
      },
    },
    {
      header: "Establecimiento SRT (Cod Int)",
      accessorKey: "codigoIntercambio",
      width: "10%",
      align: "center",
      type: "numeric",
      sorting: true,
      enableColumnFilter: false,
      enableColumnActions: false,
    },
    {
      header: "Establecimiento Empresa (MU)",
      accessorKey: "matrizUnica",
      enableColumnActions: false,
      width: "10%",
      align: "center",
      type: "numeric",
      sorting: true,
      enableColumnFilter: false,
      filtering: false,
      xlsxConfig: {
        numberFormat: "@",
      },
    },
    {
      header: "Es de Terceros",
      accessorKey: "esDeTerceros",
      enableColumnActions: false,
      minWidth: 120,
      maxWidth: 150,
      align: "center",
      sorting: true,
      enableColumnFilter: false,
    },
    {
      header: "Fecha Baja",
      accessorKey: "fechaBaja",
      enableColumnActions: false,
      width: "10%",
      align: "center",
      sorting: true,
      enableColumnFilter: false,
      Cell: ({ renderedCellValue }) => (renderedCellValue ? format(parseISO(renderedCellValue), "dd/MM/yyyy") : ""),
      xlsxConfig: {
        dateFormat: "DD/MM/yyyy",
      },
    },
  ], [data]);

  const cuit = useSelector((state) => state.informacion.datosGeneralesAfip.data?.cuit);

  return (
    <MaterialReactTable
      {...tableConfig}
      columns={columns}
      data={data}
      layoutMode="grid"
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      initialState={{ showColumnFilters: true }}
      style={{
        ...tableStyles.container,
        marginTop: '0' // Ensure no top margin that could cause overlap
      }}
      enableRowActions
      renderRowActions={
        ({ row }) => (
          <Tooltip title="Ver detalle">
            <IconButton
              size="medium"
              sx={{ color: theme.palette.primary.main, }}
              onClick={() => {
                handleVerEstadoEstablecimiento(row.original)
              }}>
              <Visibility />
            </IconButton>
          </Tooltip>
        )
      }
      positionActionsColumn="last"
      renderTopToolbarCustomActions={() => (
        <StyledEstablecimientos.ToolbarContainer>
          <ExportButton
            data={data}
            columns={columns}
            title="Establecimientos de Prevención"
            fileName={`${cuit}-Establecimientos${format(new Date(), 'yyyyMMdd')}`}
          />
          <EstablecimientosToolbar />
        </StyledEstablecimientos.ToolbarContainer>
      )}
      enableGlobalFilter={false}
      enableColumnFilters={true}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableHiding={false}
      muiTableHeadCellProps={{
        sx: {
          ...tableConfig.muiTableHeadCellProps.sx,
          justifyContent: 'start',
        }
      }}
      muiTableBodyCellProps={{
        sx: { justifyContent: 'center' }
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          muiTableHeadCellProps: {
            align: "center",
          },
          header: "",
          size: 50,
        },
      }}
    />
  );
};

export default EstablecimientosTable;
